<div #imageContainer class="">
  <img *ngIf="hasImage" src="{{imageUrl}}" alt="DXF file as an image" class="dxf-image img-fluid">
  <div *ngIf="!hasImage">{{errorMessage}}</div>
</div>